import { lang } from '@umu/ukit-lang';

/**
 * 转换成： 12,030.05
 * @param num 以分为单位的整数，如，100
 * @returns
 */
export const computeShowMoney = (num: number) => {
    const value = (num / 100).toFixed(2);
    const valArr = value.split('.');
    let inte = valArr[0];
    const fen = valArr[1];
    inte = inte.replace(/\d+/, function (s) {
        return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    });
    return `${inte}.${fen}`;
};

/**
 * 格式化货币
 * @param num {number} 要格式化的数字
 * @param n  {number | undefined} 有效数字
 */
export function formatNumToMoney(num: number, n: number | undefined) {
    if (typeof n === 'undefined') {
        n = 2;
    }
    let newNum = String(num.toFixed(n));
    const reg = /(-?\d+)(\d{3})/;
    while (reg.test(newNum)) {
        newNum = newNum.replace(reg, '$1,$2');
    }
    return newNum;
}

// 货币符 - 按站点区分
export const getCurrencySymbol = () => {
    // const currencySymbol = '￥';
    //    //    //    //    // currencySymbol = 'JPY￥';
    //    return lang('￥');
};
